import React from 'react';
import {useTranslation} from 'react-i18next';
import {FaIcon} from '../../FaIcon';

export function PrerequisitesSection() {
    const {t} = useTranslation();

    const items = [
        'dashbo_mcp.prerequisites.item_link_accounts',
        'dashbo_mcp.prerequisites.item_fix_connections',
        'dashbo_mcp.prerequisites.item_remove_inaccessible',
        'dashbo_mcp.prerequisites.item_no_partial_results',
    ];

    return (
        <div className="dashbo-mcp-section">
            <div className="prerequisites-banner">
                <div className="prerequisites-header">
                    <FaIcon iconName="clipboard-check"/>
                    <strong>{t('dashbo_mcp.prerequisites.title')}</strong>
                </div>
                <ul className="prerequisites-list">
                    {items.map((key, i) => (
                        <li key={i}>
                            <span className="prerequisites-number">{i + 1}</span>
                            <span>{t(key)}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
